import {RteTooltipLazy} from 'app/modules/editorContent/rteTooltip/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineRteTooltip(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-rte-tooltip')) {
        return;
    }

    customElements.define(
        'gem-rte-tooltip',
        class extends WebComponentLoader {
            reactLazyComponent = RteTooltipLazy;
            hasConfig = false;
        },
    );
}
